import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import BottomTab from '../components/BottomTab';
import { FiImage, FiCalendar, FiSearch } from 'react-icons/fi';
import { useNavigate , useLocation} from 'react-router-dom';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import SimpleCalendar from '../components/SimpleCalendar';
import { FaChevronRight } from 'react-icons/fa';
import { BookRegType } from '../common/enums';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { getBookByBookId, getBookByIsbn } from '../api/BookApi';
import { createBookcommunityBook } from '../api/BookcommunityApi';
import BookSearchPage from './BookSearchPage';
import { FaTimes } from 'react-icons/fa';
import LoadingOverlay from '../components/LoadingOverlay';
import { getBookcommunityBook } from '../api/BookcommunityApi';
import { CommunityType, communityType2text } from '../common/enums';
import { modifyBookcommunityBook } from '../api/BookcommunityApi';
import { stringToDate } from '../common/utils';
import MessageModal from '../components/MessageModal';

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
`;

const TabRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
`;

const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;

const ContentSection = styled.div`
  background: #fff;
  padding: 32px 20px 120px 20px;
`;

const ContentTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #404040;
  margin-bottom: 24px;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 0;
  gap: 0;
`;

const FormLabel = styled.div`
  flex: 0 0 110px;
  font-size: 15px;
  color: #444;
  font-weight: 400;
  text-align: left;
  display: flex;
  align-items: center;
`;

const FormInput = styled.input`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 14px;
  padding: 0 10px;
  box-sizing: border-box;
`;

const FormTextArea = styled.textarea`
  flex: 1;
  min-height: 80px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 14px;
  padding: 8px 10px;
  resize: none;
  box-sizing: border-box;
`;

const FormValue = styled.div`
  flex: 1;
  font-size: 16px;
  color: #444;
  text-align: left;
`;

const FormArrow = styled.span`
  margin: 0 8px;
  color: #bbb;
`;

const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
`;

const SearchIcon = styled(FiSearch)`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #bbb;
  cursor: pointer;
`;

const SearchInput = styled(FormInput)`
  padding-left: 32px;
  width: 100%;
  box-sizing: border-box;
  pointer-events: none;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 40px;
  justify-content: center;
`;

const RegisterButton = styled.button`
  flex: 1;
  max-width: 200px;
  background: ${props => props.disabled ? '#ccc' : '#244AC2'};
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  box-shadow: 0 2px 8px rgba(36,74,194,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: ${props => props.disabled ? '#ccc' : '#193a99'};
  }
`;

const CancelButton = styled.button`
  flex: 1;
  max-width: 200px;
  background: ${props => props.disabled ? '#ccc' : '#9e9e9e'};
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  box-shadow: 0 2px 8px rgba(158,158,158,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: ${props => props.disabled ? '#ccc' : '#757575'};
  }
`;

const Dropdown = styled.div`
  position: relative;
  display: inline-block;
  flex: 1;
`;

const DropdownButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-weight: 500;
  cursor: pointer;
  min-width: 80px;
  font-size: 14px;
`;

const DropdownList = styled.div`
  position: absolute;
  left: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  min-width: 180px;
  ${({ position }) => position === 'top' && 'bottom: 110%; top: auto;'}
  ${({ position }) => position === 'bottom' && 'top: 110%;'}
`;

const DropdownItem = styled.div`
  padding: 10px 18px;
  color: #555;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background: #f5f5f7;
  }
  &.selected {
    color: #1976d2;
    font-weight: 700;
  }
`;

const ArrowIcon = styled(FaChevronRight)`
  font-size: 13px;
  color: #bbb;
`;


const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;


const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;



const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;


const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 20px 20px 20px;
`;


export default function BookListRegisterPage({ bookCommunityId, bookCommunityBookId, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [bookId, setBookId] = useState(params.get('bookId'));
  const [isbn, setIsbn] = useState(params.get('isbn'));
  const { showBack, setShowBack, setLogoText } = useNoobookContext();
  const [activeTab, setActiveTab] = useState('recommend');
  const [bookTitle, setBookTitle] = useState('');
  const [bookAuthor, setBookAuthor] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [bookDescription, setBookDescription] = useState('');
  const [participationDate, setParticipationDate] = useState('');
  const [participationTime, setParticipationTime] = useState('');
  const [participantCount, setParticipantCount] = useState('');
  const [participationType, setParticipationType] = useState('');
  const [participationCondition, setParticipationCondition] = useState('');
  const [presentationDocument, setPresentationDocument] = useState('');
  const [showDateCal, setShowDateCal] = useState(false);
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);
  const [typeDropdownPosition, setTypeDropdownPosition] = useState('bottom');
  const [showBookSearchModal, setShowBookSearchModal] = useState(false);
  const [aBookCommunityId, setABookCommunityId] = useState(bookCommunityId);
  //const [communityBookData, setCommunityBookData] = useState(null);
  //const [isbn, setIsbn] = useState(params.get('isbn'));
  //const [bookId, setBookId] = useState('');
  const dateCalRef = useRef(null);
  const typeDropdownRef = useRef(null);

  const participationTypes = [
    '온라인',
    '오프라인'
  ];

  useEffect(() => {
    loadBookInfo();
  }, [bookId, isbn]);

  useEffect(() => {
    if(bookCommunityBookId) {
      loadCommunityBookData();
    }
  }, [bookCommunityBookId]);

  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(true);
    setLogoText('도서리스트 등록');
    return () => setShowBack(prevShowBack);
  }, []);

  const loadCommunityBookData = async () => {
    if (!bookCommunityBookId) {
      return;
    }

    if (loading) {
      return;
    }

    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      const response = await getBookcommunityBook(accessToken || '', bookCommunityBookId);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        //setCommunityBookData(processedResponse.data);
        //console.log('processedResponse.data', processedResponse.data);
        if(!bookCommunityId) {
            setABookCommunityId(processedResponse.data?.bookcommunityId);
        }
        console.log('bookCommunityId', bookCommunityId);
        setBookTitle(processedResponse.data?.book?.title);
        setBookAuthor(processedResponse.data?.book?.author);
        setBookDescription(processedResponse.data.bookIntroduction);
        setParticipationDate(processedResponse.data.meetingDate);
        setParticipationTime(processedResponse.data.meetingTime);
        setParticipantCount(processedResponse.data.participantNum);
        setParticipationType(processedResponse.data.meeting_type);
        setParticipationCondition(processedResponse.data.participationCondition);
        setPresentationDocument(processedResponse.data.presentationStatement);
        setBookId(processedResponse.data?.book?.id);
        setIsbn(processedResponse.data?.book?.isbn);
      } else {
        setErrorMessage(processedResponse.errorMessage || '도서 정보를 불러오는데 실패했습니다.');
      }
    } catch (err) {
      console.error('도서 데이터 로드 중 오류:', err);
      setErrorMessage('도서 정보를 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };




  const loadBookInfo = async (argBookId, argIsbn) => {
    const cbookId = argBookId || bookId;
    const cisbn = argIsbn || isbn;
    setErrorMessage('');
    if (cbookId) {
      const {accessToken} = await getAccessToken();
      const resp = await getBookByBookId(accessToken, cbookId);
      const processedResp = processApiResponse(resp);
      if(processedResp.success) {
        if(processedResp.data) {
          setBookTitle(processedResp.data.title);
          setBookAuthor(processedResp.data.author);
        }
      } else {
        setErrorMessage(processedResp.errorMessage);
      }
    } else if (cisbn) {
      const {accessToken} = await getAccessToken();
      const resp = await getBookByIsbn(accessToken, cisbn);
      const processedResp = processApiResponse(resp);
      if(processedResp.success) {
        if (processedResp.data) {    
          console.log('processedResp.data', processedResp.data);
          setBookId(processedResp.data.bookId);
          setBookTitle(processedResp.data.title);
          setBookAuthor(processedResp.data.author);
        }
      } else {
        setErrorMessage(processedResp.errorMessage);
      }
    }
};

  function handleClick(e) {
    if (typeDropdownRef.current && !typeDropdownRef.current.contains(e.target)) {
      setShowTypeDropdown(false);
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
/*
  const loadBookInfo = async () => {
    if(loading) {
      return;
    }
    setLoading(true);
    try {
      setErrorMessage('');
      if (bookId) {
        const {accessToken} = await getAccessToken();
        const resp = await getBookByBookId(accessToken, bookId);
        const processedResp = processApiResponse(resp);
        if(processedResp.success) {
          if(processedResp.data) {
            setBookTitle(processedResp.data.title);
          }
        } else {
          setErrorMessage(processedResp.errorMessage);
        }
      } else if (isbn) {
        const {accessToken} = await getAccessToken();
        const resp = await getBookByIsbn(accessToken, isbn);
        const processedResp = processApiResponse(resp);
        if(processedResp.success) {
          if (processedResp.data) {    
            setBookId(processedResp.data.id);
            setBookTitle(processedResp.data.title);
          }
        } else {
          setErrorMessage(processedResp.errorMessage);
        }
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    } 
  };
  */

  const handleTypeDropdown = () => {
    if (typeDropdownRef.current) {
      const rect = typeDropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      
      if (spaceBelow < 200 && spaceAbove > spaceBelow) {
        setTypeDropdownPosition('top');
      } else {
        setTypeDropdownPosition('bottom');
      }
    }
    setShowTypeDropdown(!showTypeDropdown);
  };

  const handleRegister = async () => {
    console.log('bookId', bookId, 'isbn', isbn);
    if (!bookId && !isbn) {
      alert('도서를 선택해주세요.');
      return;
    }
    if (!bookDescription.trim()) {
      alert('도서소개를 입력해주세요.');
      return;
    }
    if (!participationDate) {
      alert('참여일자를 선택해주세요.');
      return;
    }
    if (!participationTime.trim()) {
      alert('참여시간을 입력해주세요.');
      return;
    }
    if (!participantCount ) {
      alert('참여인원 수를 입력해주세요.');
      return;
    }
    if (!participationType) {
      alert('참여형태를 선택해주세요.');
      return;
    }
    console.log('2.bookCommunityId', aBookCommunityId);
    if (!aBookCommunityId) {
      alert('모임 ID가 없습니다.');
      return;
    }
    
    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      // createBookcommunityBook API 호출을 위한 데이터 준비
      const bookData = {
        bookcommunityId: aBookCommunityId,
        bookId: parseInt(bookId),
        bookIsbn: isbn,
        bookIntroduction: bookDescription,
        meetingDate: participationDate ? stringToDate(participationDate, 'yyyy.mm.dd', '.') : null,
        meetingTime: participationTime,
        participantNum: parseInt(participantCount),
        meeting_type: participationType ,
        participationCondition: participationCondition,
        presentationStatement: presentationDocument
      };
      
      const response = bookCommunityBookId 
           ? await modifyBookcommunityBook(accessToken || '', bookCommunityBookId, bookData) 
           : await createBookcommunityBook(accessToken || '', aBookCommunityId, bookData);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        //alert('도서리스트가 등록되었습니다!');
        if (onClose) {
          onClose(true); // 성공적으로 등록됨을 알림
        } else {
          navigate(-1);
        }
      } else {
        setErrorMessage(processedResponse.errorMessage || '도서리스트 등록에 실패했습니다.');
      }
    } catch (error) {
      console.error('도서리스트 등록 중 오류:', error);
      setErrorMessage('도서리스트 등록 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseErrorModal = () => {
    setErrorMessage('');
    
    if(onClose) {
      onClose(false);
    } else {
      navigate(-1);
    }
  };


  const handleBookSearchModalClose = (argIsbn, argBookId) => {
    setShowBookSearchModal(false);
    setIsbn(argIsbn);
    setBookId(argBookId);
    console.log('bookId', bookId, 'isbn', isbn);
    loadBookInfo(argBookId, argIsbn);
  };

  const handleSearchIconClick = () => {
    setShowBookSearchModal(true);
  };

  return (
    <PageWrapper>
      <TabRow>
        <Tab 
          active={activeTab === 'review'} 
          onClick={() => navigate('/moim')}
        >
          서평·필사단
        </Tab>
        <Tab 
          active={activeTab === 'recommend'} 
          onClick={() => navigate('/moim')}
        >
          추천모임
        </Tab>
      </TabRow>
      <ContentSection>
        {!onClose && <ContentTitle>도서리스트 등록</ContentTitle>}
        
        <FormRow>
          <FormLabel>도서명</FormLabel>
          <SearchInputWrapper>
            <SearchIcon size={20} onClick={() => /*navigate(`/book-search?bookRegType=${BookRegType.MOIM}`)*/handleSearchIconClick()} />
            <SearchInput 
              placeholder="도서를 선택해주세요"
              value={bookTitle}
              onChange={(e) => {}}
              readOnly
            />
          </SearchInputWrapper>
        </FormRow>
        
        <FormRow>
          <FormLabel>도서소개</FormLabel>
          <FormTextArea 
            placeholder="도서에 대한 간단한 소개를 입력해주세요"
            value={bookDescription}
            onChange={(e) => setBookDescription(e.target.value)}
          />
        </FormRow>
        
        <FormRow>
          <FormLabel>참여일자</FormLabel>
          <div style={{position:'relative'}} ref={dateCalRef}>
            <FormValue 
              style={{
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                cursor: 'pointer',
                fontSize: '14px'
              }}
              onClick={() => setShowDateCal(v => !v)}
            >
              {participationDate || '참여일자 선택'}
              <FiCalendar size={16} color="#bbb" />
            </FormValue>
            {showDateCal && (
              <SimpleCalendar
                value={participationDate}
                onSelect={setParticipationDate}
                onClose={() => setShowDateCal(false)}
                anchorRef={dateCalRef}
              />
            )}
          </div>
        </FormRow>
        
        <FormRow>
          <FormLabel>참여시간</FormLabel>
          <FormInput 
            placeholder="예: 14:00 ~ 16:00"
            value={participationTime}
            onChange={(e) => setParticipationTime(e.target.value)}
          />
        </FormRow>
        
        <FormRow>
          <FormLabel>참여인원 수</FormLabel>
          <FormInput 
            placeholder="참여인원 수를 입력해주세요"
            value={participantCount}
            onChange={(e) => setParticipantCount(e.target.value)}
          />
        </FormRow>
        
        <FormRow>
          <FormLabel>참여형태</FormLabel>
          <Dropdown ref={typeDropdownRef}>
            <DropdownButton onClick={handleTypeDropdown}>
              {communityType2text(participationType) || '참여형태 선택'}
              <ArrowIcon />
            </DropdownButton>
            {showTypeDropdown && (
              <DropdownList position={typeDropdownPosition}>
                {Object.values(CommunityType).map(type => (
                  <DropdownItem
                    key={type}
                    className={participationType === type ? 'selected' : ''}
                    onClick={() => {
                      setParticipationType(type);
                      setShowTypeDropdown(false);
                    }}
                  >
                    {communityType2text(type)}
                  </DropdownItem>
                ))}
              </DropdownList>
            )}
          </Dropdown>
        </FormRow>
        
        <FormRow>
          <FormLabel>참여조건</FormLabel>
          <FormTextArea 
            placeholder="참여조건을 입력해주세요"
            value={participationCondition}
            onChange={(e) => setParticipationCondition(e.target.value)}
          />
        </FormRow>
        
        <FormRow>
          <FormLabel>발제문</FormLabel>
          <FormTextArea 
            placeholder="발제문을 입력해주세요"
            value={presentationDocument}
            onChange={(e) => setPresentationDocument(e.target.value)}
          />
        </FormRow>
        
        <ButtonContainer>
          <RegisterButton onClick={handleRegister} disabled={loading}>
            { bookCommunityBookId 
                ? (loading ? '수정 중...' : '수정하기' )
                : (loading ? '등록 중...' : '등록하기')}
          </RegisterButton>
          <CancelButton onClick={() => onClose ? onClose(false) : navigate(-1)} disabled={loading}>
            취소
          </CancelButton>
        </ButtonContainer>
      </ContentSection>
      {/*<BottomTab selected="moim" onTabChange={onTabChange} />*/}
        {/* 도서 검색 모달 */}
        {showBookSearchModal && (
        <Modal>
          <ModalHeader>
            <ModalTitle>도서 검색</ModalTitle>
            <CloseButton onClick={()=>handleBookSearchModalClose(null, null)}>
              <FaTimes />
            </CloseButton>
          </ModalHeader>
          <ModalContent>
            <BookSearchPage onClose={handleBookSearchModalClose} />
          </ModalContent>
        </Modal>
      )}
       {/* 에러 메시지 모달 */}
       <MessageModal
        isOpen={!!errorMessage}
        message={errorMessage}
        onClose={handleCloseErrorModal}
        title="오류"
      />
      {/* 로딩 오버레이 */}
      {loading && <LoadingOverlay />}
    </PageWrapper>
  );
} 